<template>
  <el-container class="CustomerForm">
    <el-main>
      <el-form
        :model="data"
        :rules="rules"
        inline
        ref="form"
        label-width="90px"
        class="form-label-90"
      >
        <el-row :gutter="10">
          <el-col :span="10">
            <el-card class="box-card">
              <div slot="header">기본정보</div>
              <div>
                <el-row>
                  <el-col :span="10">
                    <el-form-item label="거래처명" prop="name">
                      <el-input v-model="data.name" maxlength="50" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="거래처구분">
                      <el-select v-model="data.type_flag" placeholder="구분">
                        <el-option
                          v-for="item in type_flag_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="거래처코드" prop="code">
                      <el-input v-model="data.code" class="readonly" readonly />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="사업구분" prop="invoice_flag">
                      <el-select v-model="data.invoice_flag">
                        <el-option
                          v-for="item in invoice_type_flag_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="identifyNumberTitle" prop="crn">
                      <el-input
                        v-show="data.invoice_flag === '1'"
                        v-model="data.crn"
                        placeholder="숫자만 입력"
                        v-mask="'##########'"
                        maxlength="10"
                        @change="handleChangeCrn"
                      />
                      <el-input
                        v-show="data.invoice_flag !== '1'"
                        v-model="data.owner_ssn"
                        v-mask="masks.ssn"
                        maxlength="14"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="대표자명" prop="owner">
                      <el-input v-model="data.owner" maxlength="25" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="업태" prop="conditions">
                      <el-input v-model="data.conditions" maxlength="25" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="종목" prop="item">
                      <el-input v-model="data.item" maxlength="25" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="담당자명" prop="charger">
                      <el-input v-model="data.charger" maxlength="25" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="대표전화" prop="tel">
                      <el-input v-model="data.tel" maxlength="20" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="연락처" prop="tel2">
                      <el-input v-model="data.tel2" maxlength="20" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="대표핸드폰" prop="owner_tel">
                      <el-input v-model="data.owner_tel" maxlength="13" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="팩스번호" prop="fax">
                      <el-input v-model="data.fax" maxlength="20" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="이메일" prop="email">
                      <el-input v-model="data.email" maxlength="50" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="해외 거래처" prop="foreign_flag">
                      <ACheckboxYN v-model="data.foreign_flag" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-col>
          <el-col :span="7">
            <el-card class="box-card">
              <div slot="header">주소정보</div>
              <div>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="우편번호" prop="zipcode">
                      <el-input
                        v-model="data.zipcode"
                        class="zipcode readonly"
                        style="width: 100px;"
                        readonly
                      />&nbsp;
                      <el-button
                        @click="popupZipcode(handleCompletedSearchZipcode)"
                        >우편번호검색</el-button
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="사업자주소"
                      prop="addr"
                      style="width: 100%;"
                      class="custom-form-item"
                    >
                      <el-input
                        ref="addr"
                        v-model="data.addr"
                        class="addr"
                        maxlength="100"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="우편번호" prop="zipcode2">
                      <el-input
                        v-model="data.zipcode2"
                        class="zipcode readonly"
                        style="width: 100px;"
                        readonly
                      />&nbsp;
                      <el-button
                        @click="popupZipcode(handleCompletedSearchZipcode2)"
                        >우편번호검색</el-button
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="납품주소"
                      prop="addr2"
                      style="width: 100%;"
                      class="custom-form-item"
                    >
                      <el-input
                        ref="addr2"
                        v-model="data.addr2"
                        class="addr"
                        maxlength="100"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="납품지" prop="delivery_addr_flag">
                      <ASelector
                        v-model="data.delivery_addr_flag"
                        valueField="value"
                        labelField="label"
                        :items="delivery_addr_items"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="화물지점" prop="freight_location">
                      <el-input
                        v-model="data.freight_location"
                        maxlength="20"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-col>
          <el-col :span="7">
            <el-card class="box-card">
              <div slot="header">부가정보</div>
              <div>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="계좌정보" prop="bank_account">
                      <el-input v-model="data.bank_account" maxlength="50" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="13">
                    <el-form-item label="거래계좌" prop="account_id">
                      <el-select
                        v-model="data.account_id"
                        placeholder="거래계좌"
                        clearable
                      >
                        <el-option
                          v-for="item in accountItems"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="여신한도" prop="credit_line">
                      <ANumberInput v-model="data.credit_line" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="기계등급" prop="customer_level_id">
                      <el-select
                        v-model="data.customer_level_id"
                        placeholder="기계등급"
                      >
                        <el-option
                          v-for="item in customer_level_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="유리등급"
                      prop="customer_glass_level_id"
                    >
                      <el-select
                        v-model="data.customer_glass_level_id"
                        placeholder="유리등급"
                      >
                        <el-option
                          v-for="item in customer_glass_level_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="도어등급"
                      prop="customer_door_level_id"
                    >
                      <el-select
                        v-model="data.customer_door_level_id"
                        placeholder="도어등급"
                      >
                        <el-option
                          v-for="item in customer_door_level_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="거래처등급" prop="client_level_id">
                      <el-select
                        v-model="data.client_level_id"
                        placeholder="거래처등급"
                      >
                        <el-option
                          v-for="item in client_level_options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="비고" prop="desc" style="width: 100%;">
                      <el-input
                        type="textarea"
                        v-model="data.desc"
                        :rows="1"
                        class="addr"
                        maxlength="200"
                        style="height: 25px;"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button type="primary" :disabled="!has_grant_write" @click="clickReg"
        >등 록</el-button
      >
      <el-button
        type="danger"
        v-if="!isNew"
        :disabled="!has_grant_write"
        @click="handleClickDelete"
        >삭 제</el-button
      >
      <el-button class="close-button" @click="handleClickClose">{{
        $t("button.close")
      }}</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";
import { zipcode_search } from "@/common/mixins/zipcode_search";

export default {
  name: "CustomerForm",
  mixins: [form, zipcode_search],
  data() {
    return {
      title: this.$t("title.customer"),
      rules: {
        name: [
          { required: true, message: "업체명을 입력하세요.", trigger: "blur" },
        ],
        invoice_flag: [
          {
            required: true,
            message: "사업자구분을 선택하세요.",
            trigger: "blur",
          },
        ],
        owner: [
          {
            required: true,
            message: "대표자명을 입력하세요.",
            trigger: "blur",
          },
        ],
        conditions: [
          { required: true, message: "업태를 입력하세요.", trigger: "blur" },
        ],
        email: [
          {
            type: "email",
            message: "올바른 메일 주소를 입력해 주세요.",
            trigger: "blur",
          },
        ],
      },
      delivery_addr_items: [
        { value: "1", label: "사업자주소" },
        { value: "2", label: "납품 주소" },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "table_customer_level",
      "table_customer_glass_level",
      "table_customer_door_level",
      "table_account",
      "table_client_level",
    ]),
    /** 신규 여부 */
    isNew: function() {
      return this.data.id < 1;
    },
    /** 거래처 구분 */
    type_flag_options: function() {
      return this.system.options.customer_type_flag;
    },
    /** 기계등급 */
    cost_grade_options: function() {
      return this.system.options.cost_grade;
    },
    customer_level_options: function() {
      let options = [{ value: null, label: "" }];
      this.table_customer_level.forEach((l) => {
        options.push({ value: l.id, label: l.code });
      });
      return options;
    },
    customer_glass_level_options: function() {
      let options = [{ value: null, label: "" }];
      this.table_customer_glass_level.forEach((l) => {
        options.push({ value: l.id, label: l.code });
      });
      return options;
    },
    customer_door_level_options: function() {
      let options = [{ value: null, label: "" }];
      this.table_customer_door_level.forEach((l) => {
        options.push({ value: l.id, label: l.code });
      });
      return options;
    },
    client_level_options: function() {
      let options = [{ value: null, label: "" }];
      this.table_client_level.forEach((l) => {
        options.push({ value: l.id, label: l.level });
      });
      return options;
    },
    invoice_type_flag_options: function() {
      return this.system.options.invoice_type_flag;
    },
    masks: function() {
      return this.system.masks;
    },
    identifyNumberTitle() {
      return this.data.invoice_flag === "1" ? "사업자번호" : "주민번호";
    },
    accountItems() {
      return this.table_account.filter((account) => account.type_id === 2);
    },
  },
  methods: {
    handleCompletedSearchZipcode(zipcode, addr) {
      this.data.zipcode = zipcode;
      this.data.addr = addr + " ";
      this.data.location = this.getLocation(addr);
      this.$refs.addr.focus();
    },
    handleCompletedSearchZipcode2(zipcode, addr) {
      this.data.zipcode2 = zipcode;
      this.data.addr2 = addr + " ";
      this.$refs.addr2.focus();
    },
    /** 등록 */
    clickReg() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.doRegister();
      });
    },
    /** 삭제 */
    handleClickDelete() {
      this.util.confirm_delete(
        this,
        "거래처[" + this.data.name + "]",
        this.handleDeleteAll
      );
    },
    /** 데이터 값 정리 */
    organizeData() {
      let data = Object.assign({}, this.data);
      data.crn = this.util.remove_dash(data.crn);
      data.ssn = this.util.remove_dash(data.ssn);
      if (data.credit_line === "") {
        data.credit_line = null;
      }
      if (data.account_id === "") {
        data.account_id = null;
      }
      return data;
    },
    getLocation(addr) {
      let arAddr = addr.split(" ");
      if (addr.length < 1 || arAddr.length < 1) return "";
      for (let i = arAddr.length - 1; i >= 0; i--) {
        if (isNaN(arAddr[i])) {
          return arAddr[i];
        }
      }
    },
    doRegister() {
      const data = this.organizeData();
      if (this.isNew) {
        this.api.createCustomer(data).then((res) => {
          this.handleResultForSave(res, true);
        });
      } else {
        this.api.updateCustomer(data).then((res) => {
          this.handleResultForSave(res);
        });
      }
    },
    doDelete() {
      const data = this.organizeData();
      this.api.deleteCustomer(data).then((res) => {
        this.handleResultForDelete(res);
      });
    },
    handleDeleteAll() {
      this.util.confirm(
        this,
        "거래처[" + this.data.name + "]",
        "삭제한 거래처와 연관된 매출/매입 정보도 함께 삭제하시겠습니까?",
        this.doDeleteAll,
        this.doDelete
      );
    },
    doDeleteAll() {
      const data = this.organizeData();
      this.api.deleteCustomerAll(data).then((res) => {
        this.handleResultForDelete(res);
      });
    },
    handleResultForSave(res, isCreate) {
      const message = isCreate ? "등록되었습니다" : "수정되었습니다.";
      this.handleResult(res, message);
    },
    handleResultForDelete(res) {
      this.handleResult(res, "삭제되었습니다.", true);
    },
    handleResult(res, successMessage, close = false) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, successMessage);
      this.$emit("completed", close);
    },
    handleClickClose() {
      this.$emit("close");
    },
    handleChangeCrn() {
      let param = {
        id: this.data.id,
        crn: this.data.crn,
      };
      this.api.checkCustomerCrn(param).then((res) => {
        if (res.error === this.system.noError) {
          return;
        }
        if (res.error === 4) {
          this.util.alert(this, this.title, "이미 등록된 사업자번호입니다.");
        } else {
          this.util.notify_response_error(this, this.title, res);
        }
      });
    },
  },
};
</script>
